import React from 'react';
import { useParams } from 'react-router-dom';

export default function ({ children }) {
  const params = useParams();
  return React.cloneElement(children, params);
}